export const PAGES = {
	DASHBOARD: "/dashboard"
}
